import { createContext, useContext } from 'react';
import { AutomationVersionSimple } from '@/types/automations.ts';

export const VersionHistoryReviewContext = createContext<
  ((targetVersion?: AutomationVersionSimple) => void) | undefined
>(undefined);

export const useVersionHistoryReview = () => useContext(VersionHistoryReviewContext);
